import React, { useEffect, useState } from 'react';
import { i18n } from 'core/i18n';
import { recordLink, recordLinkV2 } from 'utilities/tagging';

import Wizard from 'components/commons/wizard/wizard';
import WizardStep from 'components/commons/wizardStep/wizardStep';
import { OKLink } from 'commonsComponents/OKLink';
import { CardChangeNewPaymentMethodStep1 } from 'components/cards/cardChangePaymentMethodSteps/cardChangePaymentMethodStep1/cardChangeNewPaymentMethodStep1';
import { CardChangeNewPaymentMethodStep3 } from 'components/cards/cardChangePaymentMethodSteps/cardChangeNewPaymentMethodStep3/cardChangeNewPaymentMethodStep3';
import { HireCardOpenCreditStepINEDIR } from 'components/hire/cardINEDIRDocument/hireCardOpenCreditStepINEDIR';
import { CARD_PAYMENT_METHOD_UNIQUE } from 'constants/index';
import { LINK_CLICK_ACTION_EVENT, PAGE_NAME_CARD_CHANGE_NEW_PAYMENT_METHOD } from 'constants/tagging';
import { isPrintOfficeMode } from 'utilities/contactCenter/printerHelper';
import { catalogue, analyticsId } from './analytics/cardChangeNewPaymentMethodAnalytics';
import { 
    PAYMENT_METHOD_CHANGE_ACTION_CLICK,
    PAYMENT_METHOD_CHANGE_FORMAT_LINK,
    PAYMENT_METHOD_CHANGE_FORMAT_PRECONTRACTUAL_INFORMATION
} from 'constants/tagging';

const {
    VIRTUAL_CREDIT_CARD_PRODUCT_ALIAS_CC,
    NERUDA_CARD_PRODUCT_ALIAS_CC,
    VANITY_CARD_PRODUCT_ALIAS_CC,
    VIA_T_CARD_PRODUCT_ALIAS_CC,
    DIAMOND_CARD_PRODUCT_ALIAS_CC,
    OPEN_CREDIT_PRODUCT_ALIAS_CC
} = require('constants/hiringProductInformation');
export const CardChangeNewPaymentMethod = ({
    immCardChangePaymentMethod,
    validateStep,
    setVisibleStep,
    setWillCancel,
    onFinish,
    immCard,
    immGlobalVariables,
    showIneAndRevolving,
    handleAgreementCheckboxChange,
    immHireCreditLimit,
    setTooltipShown,
    handleTypeChange,
    handleValueChange,
    requestAfiInformation,
    setAFIParams,
    setInneParams,
    newSetHireCreditCardType,
    immFlagBasedFeatures,
    immPdfRevolvingPersistent,
    immHirePaymentMethod,
    setDisabledButton,
    method,
    currentMethod,
    documentRead,
    onAcceptAllDocument,
    saveDocumentList,
    checkRadioButtonIneDir,
    immHireCardNameSelector,
    immShippingAddressList,
    getPlacementIdCard,
    history,
    getServiceCodes,
    immProfile,
    isCheckboxCheckedStep1,
    setIsCheckboxCheckedStep1,
    agreeCheckboxCC,
    documentsPrintedAndSigned,
    onHandleChangeCheckBoxCC,
    processEmail,
    getHireInformation,
    setCheck,
    setMethod
}) => {
    const { formatText, FormattedText, hasTranslation } = i18n;

    const immSteps = immCardChangePaymentMethod.get(__CONTACT_CENTER__ && !isPrintOfficeMode() ? 'stepsCC' : 'steps');
    const stepsAmount = immSteps.size;
    const visibleStep = immCardChangePaymentMethod.get('visibleStep');
    const wizardClass = 'card-change-payment-method__wizard';
    const immFinalButton = 'cardChangePaymentMethod-change';
    const installments = immCardChangePaymentMethod.getIn([__CONTACT_CENTER__ && !isPrintOfficeMode() ? 'stepsCC' : 'steps', 0, 'installments']);
    const currentInstallments = immHirePaymentMethod.get('value');
    const initialDocumentsList = immCardChangePaymentMethod.get('initialDocumentsList')
    const acceptedDocument = immHirePaymentMethod.get('acceptedDocument')
    const agreeIneCheckbox = immCardChangePaymentMethod.get('agreeIneCheckbox')
    const [checkPaymentMehod, setCheckPaymentMehod] = useState(false);
    const CcConditions = currentMethod === CARD_PAYMENT_METHOD_UNIQUE ? (!currentInstallments && currentMethod !== CARD_PAYMENT_METHOD_UNIQUE)
        : !checkPaymentMehod || installments === currentInstallments
    const precontractualConfirmationLabel = [
        {
            text: 'hireCreditCard-textInfoIneDir'
        },
        {
            text: 'hireCreditCard-textLinkInfoIneDir',
            href: 'hireCreditCard-linkInfoIneDir'
        },

    ]
    const allDocumentRead = immCardChangePaymentMethod.get('allDocumentRead')
    const onCancel = () => {
        const cardId = immCard.get('cardId');

        history.push(`/myprofile/cards/${cardId}/details`);
    }
    const actions = {
        validateStep,
        setVisibleStep,
        setWillCancel,
        finish: onFinish,
        cancel: onCancel
    };
    const buildConfirmationLabel = (labels) => {
        const labelElements = labels.map(item => {
            let element = <span key={item.text}><FormattedText value={item.text} /> </span>;
            let url;

            const href = item.href;
            url = hasTranslation(href) ? formatText(href) : href;
            const pageName = PAGE_NAME_CARD_CHANGE_NEW_PAYMENT_METHOD;
            
            const handleClick = () => {
               if (pageName) {
                 recordLinkV2({
                    action: PAYMENT_METHOD_CHANGE_ACTION_CLICK,
                    format: PAYMENT_METHOD_CHANGE_FORMAT_LINK,
                    component: PAYMENT_METHOD_CHANGE_FORMAT_PRECONTRACTUAL_INFORMATION,
                    element: formatText(item.text),
                    eventCategory: pageName,
                    eventAction: PAYMENT_METHOD_CHANGE_FORMAT_PRECONTRACTUAL_INFORMATION,
                    eventLabel: formatText(item.text)
                    });
               } else {
                    recordLink(window.utag_last_name, LINK_CLICK_ACTION_EVENT, formatText(item.text));
               }
            }

            if (url) {
                element = (
                    <OKLink
                        key={item.text}
                        id={item.id}
                        target="_blank"
                        to={url}
                        modifier="emphasize"
                        onClick={() => handleClick()}
                    >
                        {element}
                    </OKLink>
                );
            }

            return element;
        });

        return labelElements;
    }
    const precontractualLabel = buildConfirmationLabel(precontractualConfirmationLabel)
    const getCardTypeName = () => {
        const isOpenCredit = immCard.get('isOpenCredit');
        const isDiamond = immCard.get('isDiamond');
        const isPremium = immCard.get('isPremium');
        const isViaT = immCard.get('isViaT');

        switch (true) {
            case isDiamond:
                return getPlacementIdCard('diamond');
            case isOpenCredit:
                return getPlacementIdCard('open-credit');
            case isPremium:
                return getPlacementIdCard('premium');
            case isViaT:
                return getPlacementIdCard('via-t');
            default:
                return getPlacementIdCard('open-credit');
        }
    };
    const getCardType = () => {
        const isOpenCredit = immCard.get('isOpenCredit');
        const isDiamond = immCard.get('isDiamond');
        const isPremium = immCard.get('isPremium');
        const isViaT = immCard.get('isViaT');
        const isVirtualCredit = immCard.get('isVirtualCredit');
        const isVanityCard = immCard.get('isVanityCard');
        const isNerudaCard = immCard.get('isNerudaCard');

        switch (true) {
            case isDiamond:
                return DIAMOND_CARD_PRODUCT_ALIAS_CC;
            case isOpenCredit:
                return OPEN_CREDIT_PRODUCT_ALIAS_CC;
            case isPremium:
                return OPEN_CREDIT_PRODUCT_ALIAS_CC;
            case isViaT:
                return VIA_T_CARD_PRODUCT_ALIAS_CC;
            case isVirtualCredit:
                return VIRTUAL_CREDIT_CARD_PRODUCT_ALIAS_CC;
            case isVanityCard:
                return VANITY_CARD_PRODUCT_ALIAS_CC;
            case isNerudaCard:
                return NERUDA_CARD_PRODUCT_ALIAS_CC;
            default:
                return OPEN_CREDIT_PRODUCT_ALIAS_CC;
        }
    };

    useEffect(() => {
        __CONTACT_CENTER__ && !isPrintOfficeMode() && getHireInformation(getCardType());
    }, []);

    const getCardServiceCode = () => {
        const isOpenCredit = immCard.get('isOpenCredit');
        const isDiamond = immCard.get('isDiamond');
        const isPremium = immCard.get('isPremium');
        const isViaT = immCard.get('isViaT');
        const isVirtualCredit = immCard.get('isVirtualCredit');
        const isVanityCard = immCard.get('isVanityCard');
        const isNerudaCard = immCard.get('isNerudaCard');
        switch (true) {
            case isDiamond:
                return getServiceCodes('diamond');
            case isOpenCredit:
                return getServiceCodes('open-credit');
            case isPremium:
                return getServiceCodes('premium');
            case isViaT:
                return getServiceCodes('via-t');
            case isVirtualCredit:
                return getServiceCodes('virtual');
            case isVanityCard:
                return getServiceCodes('vanity');
            case isNerudaCard:
                return getServiceCodes('viajera');
            default:
                return getServiceCodes('open-credit');
        }
    };
    const commonSteps = [
        <WizardStep
            position="first"
            cancelButton={true}
            nextButton={true}
            nextButtonDisabled={
                (__CONTACT_CENTER__
                    ? CcConditions
                    : method === currentMethod && installments === currentInstallments)
                || (!currentInstallments && currentMethod !== CARD_PAYMENT_METHOD_UNIQUE)
            }
        >

            <CardChangeNewPaymentMethodStep1
                immHireCreditLimit={immHireCreditLimit}
                immGlobalVariables={immGlobalVariables}
                setTooltipShown={setTooltipShown}
                handleTypeChange={handleTypeChange}
                handleValueChange={handleValueChange}
                requestAfiInformation={requestAfiInformation}
                setAFIParams={setAFIParams}
                setInneParams={setInneParams}
                newSetHireCreditCardType={newSetHireCreditCardType}
                immFlagBasedFeatures={immFlagBasedFeatures}
                immPdfRevolvingPersistent={immPdfRevolvingPersistent}
                immHirePaymentMethod={immHirePaymentMethod}
                immCardChangePaymentMethod={immCardChangePaymentMethod}
                immCard={immCard}
                setDisabledButton={setDisabledButton}
                currentInstallments={currentInstallments}
                currentMethod={currentMethod}
                immProfile={immProfile}
                agreeCheckboxCC={agreeCheckboxCC}
                isCheckboxCheckedStep1={isCheckboxCheckedStep1}
                setIsCheckboxCheckedStep1={setIsCheckboxCheckedStep1}
                setCheck={setCheck}
                checkPaymentMehod={checkPaymentMehod}
                setCheckPaymentMehod={setCheckPaymentMehod}
                setMethod={setMethod}
                pageName={PAGE_NAME_CARD_CHANGE_NEW_PAYMENT_METHOD}
            />

        </WizardStep>,

        <WizardStep
            position="last"
            cancelButton={true}
            previousButton={true}
            finishButton={true}
            addLoadingBehaviour={true}
            immFinalButton={immFinalButton}
            isLoading={immCardChangePaymentMethod.get('isFetching') || immCardChangePaymentMethod.get('processEmailLoading')}
            finalButtonDisabled={__CONTACT_CENTER__ && !isPrintOfficeMode() ? !agreeIneCheckbox : __CONTACT_CENTER__ && isPrintOfficeMode() && documentsPrintedAndSigned !== 'YES'}
        >
            <CardChangeNewPaymentMethodStep3
                contractName={immCard.get('contractName')}
                handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                immCard={immCard}
                immCardChangePaymentMethod={immCardChangePaymentMethod}
                showIneAndRevolving={showIneAndRevolving}
                immPdfRevolvingPersistent={immPdfRevolvingPersistent}
                immHirePaymentMethod={immHirePaymentMethod}
                immHireCardNameSelector={immHireCardNameSelector}
                immHireCreditLimit={immHireCreditLimit}
                immShippingAddressList={immShippingAddressList}
                placementIdCard={getCardTypeName()}
                operationParams={getCardServiceCode()}
                currentMethod={currentMethod}
                immFlagBasedFeatures={immFlagBasedFeatures}
                onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
                processEmail={processEmail}
                immProfile={immProfile}
                pageName={PAGE_NAME_CARD_CHANGE_NEW_PAYMENT_METHOD}
            />
        </WizardStep>
    ]
    const newSteps = (__CONTACT_CENTER__ && isPrintOfficeMode() || !__CONTACT_CENTER__) ? [
        ...commonSteps.slice(0, 1),
        <WizardStep
            position="middle"
            cancelButton={true}
            nextButton={true}
            nextButtonDisabled={allDocumentRead}
        >
            <HireCardOpenCreditStepINEDIR
                initialDocumentList={initialDocumentsList}
                onSavedocumentAcceptance={documentRead}
                acceptedDocument={acceptedDocument}
                onAcceptAllDocument={onAcceptAllDocument}
                precontractualLabel={precontractualLabel}
                allDocumentRead={allDocumentRead}
                saveDocumentList={saveDocumentList}
                checkRadioButtonIneDir={checkRadioButtonIneDir}
                taggingData={catalogue[analyticsId.CARD_CHANGE_NEW_PAYMENT_METHOD_STEP_2_VIEW]({ productName: getCardType() })}
                pageName={PAGE_NAME_CARD_CHANGE_NEW_PAYMENT_METHOD}
            />
        </WizardStep>,
        ...commonSteps.slice(1)
    ] : commonSteps;

    const tealiumData = [
        catalogue[analyticsId.CARD_CHANGE_NEW_PAYMENT_METHOD_STEP_1_VIEW]({}),
        catalogue[analyticsId.CARD_CHANGE_NEW_PAYMENT_METHOD_STEP_2_VIEW]({}),
        catalogue[analyticsId.CARD_CHANGE_NEW_PAYMENT_METHOD_STEP_3_VIEW]({})
    ];

    const tealiumEvents = {
          cancel: catalogue[analyticsId.CARD_CHANGE_NEW_PAYMENT_METHOD_CANCEL]({ pageName: PAGE_NAME_CARD_CHANGE_NEW_PAYMENT_METHOD }),
          finish: catalogue[analyticsId.CARD_CHANGE_NEW_PAYMENT_METHOD_WIZARD_FINISH]({ pageName: PAGE_NAME_CARD_CHANGE_NEW_PAYMENT_METHOD }),
          next: catalogue[analyticsId.CARD_CHANGE_NEW_PAYMENT_METHOD_NEXT]({ pageName: PAGE_NAME_CARD_CHANGE_NEW_PAYMENT_METHOD }),
          previous: catalogue[analyticsId.CARD_CHANGE_NEW_PAYMENT_METHOD_PREVIOUS]({ pageName: PAGE_NAME_CARD_CHANGE_NEW_PAYMENT_METHOD })
        };

    return (
        <Wizard
            wizardClass={wizardClass}
            actions={actions}
            immSteps={immSteps}
            stepsAmount={stepsAmount}
            visibleStep={visibleStep}
            showPreLeaveModal={!immCard.get('isNerudaCard') && !immCard.get('isVanityCard')}
            tealium={tealiumData[visibleStep - 1]}
            tealiumEvents={tealiumEvents}
            isTaggingSecondVersion
        >
            {newSteps}
        </Wizard>
    );
};

